import { Activities } from "../api/server/collections/activities";
import { Companies } from "../api/server/collections/companies";
import { LogMessages } from "../api/server/collections/logmessages";
import { Logs } from "../api/server/collections/logs";
import { Pictures } from "../api/server/collections/pictures";
import { Projects } from "../api/server/collections/projects";
import { Updates } from "../api/server/collections/updates";

import { RawUpdates } from "../api/server/collections/rawUpdates";
import { Users } from "../api/server/collections/users";
import { HTTP } from '@ionic-native/http/ngx';

import { Injectable, OnInit } from '@angular/core';
import { HttpClient, HttpClientModule, HttpHeaders, HttpBackend, HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Http, HttpModule} from '@angular/http'
import { AuthenticationService } from "./congito";
import { Observable } from "rxjs/Observable";
import { analyzeAndValidateNgModules } from "@angular/compiler";
import { SharedService } from "./sharedService";
import { environment } from "../environments/environment"; // This allows us to switch the Base URL based on the build type



const axios = require('axios');

const onlineCollectionMap = {
  Activities,
  Companies,
  LogMessages,
  Logs,
  Pictures,
  Projects,
  Updates,
  Users,
  RawUpdates
};
var AWS = require('aws-sdk');

declare var gtag; // Global variable for Google Tag manager, used for Google Analytics

@Injectable()
export class HttpService {

  // Set the base URL, as environment-specific (dev or prod)
  private slsUrl = environment.baseURL; 

  // private slsUrl = 'http://localhost:3001';
  // private slsUrl = 'https://jla50o7826.execute-api.us-east-1.amazonaws.com/dev';
  // private slsUrl = 'https://368pkc761k.execute-api.us-east-1.amazonaws.com/dev'; //prod


  // private executionLambda = 'logit-sls-be-dev-directlambda';
  private executionLambda = 'logit-sls-be-prod-dev-directlambda';

  subscriptions: Array<any>= [{
    subscription: "userData",
    params: []
  }];
  inProgress:Boolean=false;
  lastDate:Date= new Date();
  newAddition:boolean=true;
  exampleSocket:any;
  connectionId:any;

  constructor(
    private authenticationService: AuthenticationService,
    private http: HttpClient,
    private ionicHTTP: HTTP,
    private sharedService: SharedService
  ) {

    this.login();
    // const subscriptionLoop = setInterval(async () => {
    //   this.privateLoopAction();

    // }, 500);
  }

  async login(){
    if(await this.authenticationService.getHeader()){
      if(this.exampleSocket){
        return this.MeteorCall('updateConnectionToUser', this.connectionId);
      } else{
        this.exampleSocket = new WebSocket(environment.websocketURL, "$connect");
        console.log("Connecting over Web Sockets, readyState is: " + this.exampleSocket.readyState);
        this.exampleSocket.onmessage=(event)=>{
          const message = JSON.parse(event.data);
          console.log("this is the message", message)
          if(message.connectionId){
            this.connectionId=message.connectionId;
            return this.MeteorCall('updateConnectionToUser', message.connectionId);
          } else{
            this.sharedService.collectionUpdated.emit();
          }
        }
      }
    }

  }

  async privateLoopAction(force?:any){

    // Google Analytics timer start
    const preRequest: number = new Date().getTime();

    const lastUpdatedTime =force || await this.http.get(`https://logit-test-test.s3.amazonaws.com/refreshkey.json`)
      .toPromise()
      .then((res:any) => new Date(res['date'])).catch(err=>console.log(err));
    if(force || (lastUpdatedTime>this.lastDate) || this.newAddition) {
      const getHeader = await this.authenticationService.getHeader();
      const httpOptions = await this.getHttpOptions();
      const subscriptions = `{
        "subscriptions": ${JSON.stringify(this.subscriptions)}
      }`;
      if(!this.inProgress){
        this.inProgress=true;
        this.newAddition=false;
        this.lastDate=new Date();
        return this.http.post(`${this.slsUrl}/api/subscribe`, subscriptions, httpOptions)
        .toPromise()
        .then(res => {
          const bufferToStr = Buffer.from(res).toString('utf8');
          const resObj = JSON.parse(bufferToStr);
          this.updateSub(resObj);
          this.inProgress=false;
          this.sharedService.httpUpdate.emit("updated");

          // Google Analytics timer stop
          const postRequest: number = new Date().getTime()

          // Calculate the elapsed time, in milliseconds
          const elapsedTime:number = (postRequest - preRequest); 
          
          // Send the measurement to Google Analytics
          gtag('event', 'timing_complete', {
            'name' : 'privateLoopAction',
            'value' : elapsedTime,
            'event_category' : 'Subscription'
          });

        })
        .catch(err => {console.log(err);this.inProgress=false;});
      }
    }
  }

  private updateSub(subscriptionInformation: any) {
    // console.log(Object.keys(subscriptionInformation))
    // Object.keys(subscriptionInformation).forEach(collectionName=>{
    //   console.log(collectionName)
    //   onlineCollectionMap[collectionName].remove({})
    //   subscriptionInformation[collectionName].forEach(item=>{
    //     onlineCollectionMap[collectionName].insert(item);
    //   })
    // })

    // return;

    try {
      // sync subscriptions by removing
      // checking for collections on frontend that are not on backend
      const oldCollectionNames = Object.keys(onlineCollectionMap);
      for (let collectionName of oldCollectionNames) {
        let oldCollectionValues = subscriptionInformation[collectionName];
        let newCollectionValues = onlineCollectionMap[collectionName];
        if (!newCollectionValues) {
          // frontend collection found that doesn't exist in backend collection
          // remove frontend collection to be consistent with backend
          oldCollectionValues.remove({});
        }
      }

      // sync subscriptions by updating/inserting
      // checking for collections on backend that are not on frontend
      const newCollectionNames = Object.keys(subscriptionInformation);
      for (let collectionName of newCollectionNames) {
        let newCollectionValues = subscriptionInformation[collectionName];
        let oldCollectionValues = onlineCollectionMap[collectionName];
        newCollectionValues.forEach(item => {
          // const foundItem = oldCollectionValues.findOne({ _id: item._id });
          // console.log('found item?', foundItem)
          oldCollectionValues.update({ _id: item._id }, item, { multi: true, upsert: true });
        });
      }

    } catch (err) {
      console.log('erroring syncing subscription collections:', err);
    }
  }

  public postSls(url: string, data: any, options?: any) {
    const _url = this.slsUrl+ `/api` + url;
    return this.http.post(_url, data, options).toPromise();
  }

  public clearSubscriptions() {
    this.subscriptions= [{
      subscription: "userData",
      params: []
    }];
  }

  async getHttpOptions(): Promise<any>{
    const authorization: string = await this.authenticationService.getHeader();
    const results =  {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        "Authorization": authorization,
      }),
      responseType: 'text' as 'text'
    };
    return results;
  }

  public refreshSubscriptions(){
    this.newAddition=true;
    return this.privateLoopAction();
  }


  public getSls(url: string) {
    const _url = this.slsUrl+`/api` + url;
    return this.http.get(_url).toPromise();
  }
  private run1 = 1
  public async lambdaDirectCall(method:string, ...methodParameters):Promise<any>{
    if(this.run1<2){
      this.run1=this.run1+1;
    const credentials = await this.http.post(`${this.slsUrl}/api/meteormethod`, {
      meteorMethod: 'getLambdaCredentials',
      parameters: []
    }, await this.getHttpOptions())
    .toPromise()
    .then(res => JSON.parse(Buffer.from(res).toString('utf8')));

    AWS.config.update({
      accessKeyId: credentials.Credentials.AccessKeyId,
      secretAccessKey: credentials.Credentials.SecretAccessKey,
      sessionToken: credentials.Credentials.SessionToken,
      region: 'us-east-1'
    });
    console.log("credentialscredentialscredentials", AWS.config)
    var lambda = new AWS.Lambda();
    const payload = JSON.stringify({
      "method":method,
      "parameters": methodParameters,
      "user": await this.authenticationService.getHeader()
    });
    console.log("payloadpayloadpayloadpayload", payload)
    var params = {
      ClientContext: AWS.util.base64.encode(JSON.stringify({
        "filler":"info"
      })),
      FunctionName: this.executionLambda,
      InvocationType: "RequestResponse",
      // LogType: "Tail",
      Payload: payload,
      // Qualifier: "1"
     };
    }

    console.log("credentials")
    let response;
    try{
      response=await lambda.invoke(params).promise()
      console.log("responseresponseresponse", response)
      response=JSON.parse(response).Payload;
      console.log("responseresponseresponse", response)
    } catch(err){
      console.log("invokation erroor", err)
    }


    return ;
  }

  public async MeteorCall(method:string, ...methodParameters):Promise<any>{

    // Google Analytics timer start
    const preRequest: number = new Date().getTime();

    // http://localhost:3000/meteormethod
    // {
    //   "meteorMethod": "getActivity",
    //   "parameters": [
    //     "xEo9TgojYAMdPgF86"
    //   ]
    // }
    // if(method==='addUpdate'){
    //   return this.lambdaDirectCall(method, ...methodParameters);
    // }

    return this.http.post(`${this.slsUrl}/api/meteormethod`, {
      meteorMethod: method,
      parameters: methodParameters
    }, await this.getHttpOptions())
    .toPromise()
    .then(res => {
      try {
        if (!res) {
          return res;
        } else {
          const bufferToStr = Buffer.from(res).toString('utf8');
          const resObj = JSON.parse(bufferToStr);
          if(resObj==="UPDATE IS ARCHIVED") {
            this.refreshSubscriptions().then(res=>{
              this.sharedService.updatePeriodGone.emit("updated");
            });
          }

          // Google Analytics timer stop
          const postRequest: number = new Date().getTime()

          // Calculate the elapsed time, in milliseconds
          const elapsedTime:number = (postRequest - preRequest); 

          // Send the measurement to Google Analytics
          gtag('event', 'timing_complete', {
            'name' : 'method',
            'value' : elapsedTime,
            'event_category' : 'MeteorCall'
          });
          
          return resObj;
        }
      } catch (err) {
        console.log('/meteormethod POST error:', err)
        return res;
      }   
    });

  }

  public async MeteorSubscribeAndRun(publication: string, ...subscriptionParameters) {
    const exists=this.subscriptions.find(subscription=>{
      return subscription.subscription===publication && subscriptionParameters.length==subscription.params.length && subscriptionParameters.every((param, index)=>{
        try{
          return param==subscription.params[index];
        }catch(err){
          return false;
        }
      })
    });
    if(!exists){
      const newSubscription = {
        subscription: publication,
        params: subscriptionParameters
      };
      this.subscriptions.push(newSubscription);
      this.newAddition=true;
      return newSubscription;
    }
    return;
  }

  public async MeteorSubscribeAnyway(publication: string, ...subscriptionParameters) {
    this.newAddition=true;
    this.MeteorSubscribe(publication, ...subscriptionParameters);
  }

  public async MeteorSubscribe(publication: string, ...subscriptionParameters) {
    const exists=this.subscriptions.find(subscription=>{
      return subscription.subscription===publication && subscriptionParameters.length==subscription.params.length && subscriptionParameters.every((param, index)=>{
        try{
          return param==subscription.params[index];
        }catch(err){
          return false;
        }
      })
    });
    if(!exists){
      const newSubscription = {
        subscription: publication,
        params: subscriptionParameters
      };
      this.subscriptions.push(newSubscription);
      this.newAddition=true;
      return newSubscription;
    }
    return;
  }

  public uploadS3File(url: string, fileName: string, type: string, file: Blob): Promise<any> {
    const blobToFile = (theBlob: Blob, fileName: string): File => {
      const file: File = new File(
        [theBlob],
        fileName,
        { type: type, lastModified: Date.now() }
      );
      return file;
    };
    const fileFromBlob = blobToFile(file, fileName);
    const headers = new HttpHeaders({ 'Content-Type': type });
    const options = {
      headers,
      responseType: 'text' as 'text'
    };
    console.log('sending upload...')
    return this.http.put(url, fileFromBlob, options).toPromise();
  }
}



// WEBPACK FOOTER //
// ./src/services/httpService.ts